import { styled } from '@mui/material/styles'

type PanelBodyProps = {
  padding?: number
  disableFlexGrow: boolean
  panelTop: string
  panelBottom: string
}

export const PanelBody = styled('div', {
  name: 'PanelBody',
  slot: 'Root',
  skipSx: true,
  skipVariantsResolver: true,
  shouldForwardProp: (prop) =>
    prop !== 'padding' &&
    prop !== 'disableFlexGrow' &&
    prop !== 'panelTop' &&
    prop !== 'panelBottom',
})<PanelBodyProps>(
  ({ theme, padding = 2, disableFlexGrow, panelTop, panelBottom }) => ({
    overflow: 'hidden auto',
    padding: theme.spacing(padding),
    position: 'absolute',
    bottom: panelBottom,
    top: panelTop,
    width: '100%',
    flexGrow: disableFlexGrow ? 0 : 1,
    '> hr': {
      marginLeft: theme.spacing(-padding),
      marginRight: theme.spacing(-padding),
    },
  }),
)
